import styled from 'styled-components';
import { Collapse as CollapseAtom } from 'components/atoms/collapse';
import { Modal as OzoneModal } from 'components/atoms/modal';
import { BodyShort02 } from 'components/styles';
import { TabbedMemberList } from '../tabbed-member-list';

export const Modal = styled(OzoneModal)`
  .ant-modal-body {
    max-height: 60vh;
    padding-top: var(--spacing-05);
  }
  .ant-modal-footer {
    border-top: solid 1px var(--border-color);
    padding: var(--layout-01);
  }

  .invite-modal--cta {
    display: none;
    pointer-events: none;
  }

  .invite-modal--empty-state {
    height: calc(100% - var(--layout-01));
    margin-bottom: var(--layout-01);
  }
`;

export const Collapse = styled(CollapseAtom)`
  .ant-collapse-item {
    .ant-collapse-header {
      display: inline-flex;
      padding-right: var(--spacing-08);
      ${BodyShort02};
      svg {
        top: 16px;
      }
      &:hover {
        background-color: transparent;
      }
    }
    &.ant-collapse-item-active {
      paddiing-bottom: 0px;
    }
  }
`;

export const MemberList = styled(TabbedMemberList)`
  height: calc(60vh - 193px);
`;
